import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Card } from "primereact/card";
import { Message } from "primereact/message";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import {
  API_ADD_SUBSCRIPTION,
  API_GET_SUBSCRIPTION,
  API_UPGRADE_SUBSCRIPTION,
} from "../../api/company.service";

const subscriptionOptions = [
  { label: "Trial", value: "10", id: 1 },
  { label: "Basic", value: "1", id: 2 },
  { label: "Standard", value: "2", id: 3 },
  { label: "Pro", value: "3", id: 4 },
];

const Subscription = () => {
  const { companyId } = useParams();
  const [subscriptionData, setSubscriptionData] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchSubscription = async () => {
    try {
      const data = await API_GET_SUBSCRIPTION(companyId);
      setSubscriptionData(data.subscription);
      setSelectedPlan(
        data.subscription?.subscriptiontype?.name?.toLowerCase() || null
      );
    } catch (error) {
      console.error("Error fetching subscription details:", error);
    }
  };

  useEffect(() => {
    fetchSubscription();
  }, [companyId]);

  const handleUpgrade = async () => {
    if (!selectedPlan) return;

    const selectedOption = subscriptionOptions.find(
      (option) => option.value === selectedPlan
    );

    if (!selectedOption) return;

    try {
      let Subscriptionpayload = {
        companyId: companyId,
        subscriptiontypeId: selectedOption.value,
        paymentType: selectedOption.value === 10 ?"prepaid" :"postpaid",
      };
      setLoading(true);
      if (subscriptionData) {
        await API_UPGRADE_SUBSCRIPTION(Subscriptionpayload);
      } else {
        await API_ADD_SUBSCRIPTION(Subscriptionpayload);
      }
      await fetchSubscription(); // Refresh subscription info
    } catch (error) {
      console.error("Error updating subscription:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4">
      <Card
        title="Subscription Management"
        subTitle="View or update the company's current plan"
        className="shadow-3 border-round-lg"
      >
        <div className="flex flex-column gap-4">
          {/* Info Section */}
          <div className="flex flex-column gap-2">
            {subscriptionData ? (
              <>
                <Message
                  severity="info"
                  className="w-full"
                  text={
                    <div className="flex justify-between">
                      <span className="font-semibold">Payment Type:</span>
                      <span>{subscriptionData.paymentType}</span>
                    </div>
                  }
                />
                <Message
                  severity="success"
                  className="w-full"
                  text={
                    <div className="flex justify-between">
                      <span className="font-semibold">Current Plan:</span>
                      <span>{subscriptionData.subscriptiontype.name}</span>
                    </div>
                  }
                />
              </>
            ) : (
              <Message
                severity="warn"
                text="No subscription details available"
              />
            )}
          </div>

          {/* Upgrade Section */}
          <div className="flex flex-column md:flex-row align-items-end justify-content-between gap-4">
            <div className="flex flex-column gap-2 w-full md:w-4">
              <label htmlFor="plan" className="text-sm font-medium">
                Select New Plan
              </label>
              <Dropdown
                id="plan"
                value={selectedPlan}
                options={subscriptionOptions}
                onChange={(e) => setSelectedPlan(e.value)}
                placeholder="Choose a plan"
                className="w-full"
              />
            </div>

            <Button
              label="Upgrade Plan"
              icon="pi pi-sync"
              onClick={handleUpgrade}
              disabled={!selectedPlan || loading}
              loading={loading}
              className="w-full md:w-auto mt-2 md:mt-0"
              style={{ backgroundColor: "#4f46e5", border: "none" }}
            />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Subscription;
